import React from 'react';

interface LoadingProps {
  variant?: 'spinner' | 'skeleton' | 'overlay';
  size?: 'small' | 'medium' | 'large';
  color?: string;
  rows?: number; // For skeleton variant
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({ 
  variant = 'spinner', 
  size = 'medium',
  color = 'border-slate-200',
  rows = 5,
  className = ''
}) => {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-16 w-16'
  };

  const borderWidth = {
    small: 'border-b-2',
    medium: 'border-b-2',
    large: 'border-4'
  };

  if (variant === 'overlay') {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
        {/* Modern dual-ring spinner */}
        <div className="relative">
          {/* Outer ring */}
          <div
            className="h-16 w-16 border-4 border-orange-500 border-t-transparent rounded-full animate-[spin_0.9s_linear_infinite]"
          />
          {/* Inner counter-rotating ring */}
          <div
            className="absolute inset-0 m-auto h-12 w-12 border-4 border-orange-300 border-b-transparent rounded-full animate-[spin_1.2s_linear_infinite_reverse]"
          />
        </div>
      </div>
    );
  }

  if (variant === 'skeleton') {
    return (
      <div className={`bg-white rounded-xl shadow-sm border border-slate-200 p-6 ${className}`}>
        <div className="animate-pulse space-y-4">
          {[...Array(rows)].map((_, i) => (
            <div key={i} className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-slate-200 rounded-full"></div>
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-slate-200 rounded w-1/4"></div>
                <div className="h-3 bg-slate-200 rounded w-1/2"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Default spinner variant
  return (
    <div className={`flex items-center justify-center py-12 ${className}`}>
      <div className={`animate-spin rounded-full ${sizeClasses[size]} ${borderWidth[size]} ${color}`}></div>
    </div>
  );
};

export default Loading;